import Add from "../../table/Add";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routers/routes";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

import ApiService from "../../../services/apiService";
import {toast} from "react-toastify";
import { addEmail,emailTitle } from "../../../constants";

const AddEmail = () => {

  const navigate = useNavigate();

        const postEmail =  async (data:any)=>{

            try{
                const response = await ApiService.axiosApi('/email',{
                    method : 'POST',
                    data : data
                })

                if(response.success){
                    toast.success(response.message || "Email Added Successsfully")
                    navigate(-1)
                }else{
                    toast.error(response.message||"Unable to add Email")
                }
            }catch(error:any){
                toast.error(error.message || "Unable to add Email")
            }
        }
  

    return(
        <Add
           title = {addEmail}
           parentTitle = {emailTitle}
           onSubmit = {postEmail}

           fields = {[
            {
                name : "email",
                label : "Email",
                type : "email",
                validation : {required : "Email is required"}
            },
            {
                name : "name",
                label : "Name",
                type : "text",
                validation : {required : "Name is required"}
            }
           ]}
        />
    )

}

export default AddEmail;
